import React from "react";

const EngagementCard = ({ value, label, subtitle }) => {
  return (
    <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg p-8 text-white hover:shadow-xl transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold opacity-90">{label}</h3>
        <div className="p-3 bg-white bg-opacity-20 rounded-lg">
          <span className="text-2xl">⏱️</span>
        </div>
      </div>
      <div className="mb-2">
        <p className="text-5xl font-bold mb-2">{value}</p>
        {subtitle && (
          <p className="text-sm opacity-80">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default EngagementCard;


